import getResponseJson from './getresponsejson';

const contractManagementPageService = serviceRoutes => {
  const init = () => {
    return fetch(serviceRoutes.init, {
      credentials: 'include'
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  const selectContract = contractId => {
    return fetch(`${serviceRoutes.selectContract}?id=${contractId}`, {
      credentials: 'include'
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  return {
    init,
    selectContract,
    serviceRoutes
  };
};

export default contractManagementPageService;
